import './scss/main.scss';
import './js/scripts';
import './js/components/lazy-load';
import { toggleSectionHeader } from './js/components/section-header.js';

toggleSectionHeader();
